module.exports = __webpack_public_path__ + "img/aac.6b71e077.svg";